export const videosData = {
  dashboard: 'https://player.vimeo.com/video/1142404639',
  dashboard_beginner: 'https://player.vimeo.com/video/1142405764',
  bulletins: 'https://player.vimeo.com/video/1036331116',
  biddings: 'https://player.vimeo.com/video/1038564619',
  followup: 'https://player.vimeo.com/video/1142395848',
  imminence: 'https://player.vimeo.com/video/1142397313',
  management: 'https://player.vimeo.com/video/1142398490',
  monitoring: 'https://player.vimeo.com/video/1142396205',
  portals: 'https://player.vimeo.com/video/1143162951',
  market: 'https://player.vimeo.com/video/1142395570',
  ata: 'https://player.vimeo.com/video/1142396672',
  contracts: 'https://player.vimeo.com/video/1142511857',
  my_history: 'https://player.vimeo.com/video/1142401627',
  juridico: 'https://player.vimeo.com/video/1143147817',
};

export type VideoDataKey = keyof typeof videosData;
